import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const useDeleteOrder = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: (orderId: string) => OrdersClient.deleteOrder({ orderId }),
    onSuccess,
    onError,
  });

  return {
    deleteOrder: mutate,
  };
};
